import React, { useCallback } from 'react';
import QuantityEditModal from '~/app/common/QuantityEditModal';
import useTranslation from '~/app/hooks/useTranslation';
import { Part } from '~/types';

export interface QuantityEditFormProps {
  open: boolean
  onClose: () => void
  part?: Part
  onSave: (part: Part, quantity: number) => void
}

export type QuantityEditFormComponent = React.FC<QuantityEditFormProps>

const QuantityEditForm: QuantityEditFormComponent = ({ open, onClose, part, onSave }) => {
  const { t } = useTranslation('parts');

  const handleSave = useCallback((quantity: number) => {
    if (!part) {
      return;
    }
    onSave(part, quantity);
  }, [part, onSave]);

  return (
    <QuantityEditModal
      open={open}
      onClose={onClose}
      name={part?.article_name ?? ''}
      subtitle={part ? `${t('partNo')}: ${part.article_no}` : undefined}
      quantity={part?.quantity ?? 0}
      onSave={handleSave}
    />
  );
};

export default QuantityEditForm;
